// extracted by mini-css-extract-plugin
module.exports = {"container":"Calendar_container__2_KjH","left":"Calendar_left__3o5q8","right":"Calendar_right__fMZrv"};